import { TelaInicialComponent } from './module/tela-inicial/tela-inicial.component';
import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AdminComponent} from './layout/admin/admin.component';
import {AuthComponent} from "./layout/auth/auth.component";
import {AuthGuardService} from "./guards/auth-guard.service";
import { AuthGuardPermissionService } from './guards/auth-guard-permission.service';

const routes: Routes = [
  {
    path: '',
    component: AdminComponent,
    children: [
      {
        path: '',
        component: TelaInicialComponent,
        canActivate: [AuthGuardService]
      }
    ]
  },
  {
    path: '',
    component: AuthComponent,
    children: [
      {
        path: '',
        redirectTo: 'auth',
        pathMatch: 'full'
      },
      {
        path: 'auth',
        loadChildren: () => import('./module/auth/auth.module').then(m => m.AuthModule)
      }
    ]
  },
  {
    path: '',
    component: AdminComponent,
    children: [
      {
        path: 'movimentacao',
        loadChildren: () => import('./module/movimentacao/movimentacao.module').then(m => m.MovimentacaoModule),
        canActivate: [AuthGuardService],
        canActivateChild: [AuthGuardPermissionService]
      }
    ]
  },
  {
    path: '',
    component: AdminComponent,
    children: [
      {
        path: 'cadastro',
        loadChildren: () => import('./module/cadastro/cadastro.module').then(m => m.CadastroModule),
        canActivate: [AuthGuardService],
        canActivateChild: [AuthGuardPermissionService]
      }
    ]
  },
  {
    path: '',
    component: AdminComponent,
    children: [
      {
        path: 'manutencao',
        loadChildren: () => import('./module/manutencao/manutencao.module').then(m => m.ManutencaoModule),
        canActivate: [AuthGuardService],
        canActivateChild: [AuthGuardPermissionService]
      }
    ]
  },
  {
    path: '',
    component: AdminComponent,
    children: [
      {
        path: 'relatorio',
        loadChildren: () => import('./module/relatorio/relatorio.module').then(m => m.RelatorioModule),
        canActivate: [AuthGuardService],
        canActivateChild: [AuthGuardPermissionService]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true})],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
